<template>
  <div>
    <div>
      <SakertMeddelandeBubble
        v-if="firstPost"
        :sakertMeddelande="firstPost"
        :align="true"
        :showVerified="showVerified"
      />
    </div>
    <div class="mt-xs flex flex-col gap-xs" v-if="!expanded">
      <SakertMeddelandeBubble
        v-for="(incomingMessage, index) in unansweredMessagesBeyondFirstPost"
        :key="index"
        :sakertMeddelande="incomingMessage!"
        :align="true"
        :showVerified="showVerified"
      />
    </div>
    <div class="mt-xs flex flex-col gap-xs" v-if="expanded">
      <SakertMeddelandeBubble
        v-for="(conversation, index) in theRest"
        :key="index"
        :sakertMeddelande="conversation"
        :align="true"
        :showVerified="showVerified"
      />
    </div>
    <div class="flex flex-col items-center">
      <avtalat-button
        class="ml-xs mt-xs"
        id="toggle-sakra-meddelande"
        v-if="showExpandButton"
        v-on:click.prevent="() => (expanded = !expanded)"
        style="color: teal; border-color: teal"
        small
        outlined
        color="blue"
        >{{ expanded ? "Dölj alla" : "Visa alla" }}</avtalat-button
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import type { ISakertMeddelande } from "@/composables/KundserviceAppApiClient";

import SakertMeddelandeBubble from "./SakertMeddelandeBubble.vue";

const props = defineProps<{
  sakraMeddelanden: ISakertMeddelande[];
  showVerified: boolean;
  heading: string;
  disableExpand?: boolean;
}>();

const expanded = ref(props.disableExpand);

const orderedConversation = computed(() => {
  return [...props.sakraMeddelanden].sort((a, b) => {
    return b.createdAt!.getTime() - a.createdAt!.getTime();
  });
});

const firstPost = computed(() => {
  return orderedConversation.value[0];
});

const unansweredMessagesBeyondFirstPost = computed(() => {
  const incomingMessages = orderedConversation.value.filter(
    (conversation) => conversation.createdByCustomer,
  );

  const latestNonIncomingMessage = orderedConversation?.value?.filter(
    (conversation) => !conversation.createdByCustomer,
  )?.[0];

  let unansweredMessages = [];

  if (latestNonIncomingMessage) {
    unansweredMessages = incomingMessages?.filter(
      (conversation) =>
        conversation.createdAt &&
        conversation.createdAt >
          (latestNonIncomingMessage.createdAt
            ? latestNonIncomingMessage.createdAt
            : 0),
    );
  } else {
    unansweredMessages = incomingMessages;
  }

  return unansweredMessages.slice(1);
});

const theRest = computed(() => {
  return orderedConversation.value.slice(1) ?? [];
});

const areAllMessagesUnanswered = computed(() => {
  return (
    theRest.value.length === unansweredMessagesBeyondFirstPost.value.length
  );
});

const showExpandButton = computed(() => {
  return (
    theRest.value.length > 0 &&
    !areAllMessagesUnanswered.value &&
    !props.disableExpand
  );
});
</script>
